import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { StoreService } from 'app/ngrx/store.service';
import { hasProfile } from 'app/shared/utils';
import { hasEspaceProjetAccess } from 'app/shared/utils/espace-projet-access.util';

@Injectable({ providedIn: 'root' })
export class EspaceProjetGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly storeService: StoreService
  ) {}

  // Admin E. Partenaire sur un partenaire / mandataire sans Espace Projet : renvoi vers la liste Dossiers
  canActivate(): boolean | UrlTree {
    const user = this.storeService.getConnectedUser();
    return hasProfile(user, ['Admin E. Partenaire']) && !hasEspaceProjetAccess(user)
      ? this.router.parseUrl('/partners/drop-list')
      : true;
  }
}
